const VERSION = '__VERSION__'

export interface VersionInfo {
  version: string
  major: number
  minor: number
  patch: number
  build?: string
}

export function getVersion(): string {
  return VERSION
}

export function getVersionInfo(): VersionInfo {
  const parts = VERSION.split('.')
  return {
    version: VERSION,
    major: parseInt(parts[0], 10) || 0,
    minor: parseInt(parts[1], 10) || 0,
    patch: parseInt(parts[2], 10) || 0,
  }
}

export function compareVersion(version: string): number {
  const current = getVersion().split('.').map(Number)
  const target = version.split('.').map(Number)

  for (let i = 0; i < Math.max(current.length, target.length); i++) {
    const c = current[i] || 0
    const t = target[i] || 0
    if (c > t) return 1
    if (c < t) return -1
  }
  return 0
}
